const $ = window.jQuery;

export function isDesktop() {
	return $( window ).width() > 991;
}
